export default {
  path: '',
  component: () => import(`@/component/admin-layout/index.vue`),
  children: [
    {
      path: '/admin/v-for-test',
      name: 'admin-v-for-test',
      component: () => import(`./index.vue`),
      meta: {
        entity_for_history_tag: {
          name: `v-for-test`,
        },
        entity_list_for_breadcrumb: [
          {name: `示例功能`},
          {name: `v-for-test`},
        ],
      },
    },
  ],
};
